/* eslint-disable */

import convert from 'xml-js'
import moment, { lang } from 'moment'
import { _ } from 'vue-underscore';
export default {
    install: Vue => {
        Vue.prototype.$request = {
            convertToXml: function (login, requestPayload, pass, captchaToken, sms) {
                const data = { login: login };

                if (requestPayload)
                    data.payload = normalizePayload(requestPayload);

                if (pass != null)
                    data.password = pass;

                if (captchaToken != null)
                    data.captcha = captchaToken;

                if (sms != null)
                    data.smsCode = sms;

                return convert.json2xml({ data: data }, {
                    compact: true,
                    ignoreComment: true,
                    fullTagEmptyElement: true,
                    elementNameFn: function (name) {
                        return name.charAt(0).toUpperCase() + name.slice(1);
                    }
                });
            },
            getToken(vue, login, password, onSuccess, onError) {
                const data = { login: login, password: password };

                _signThenSendRequest.call(
                    vue,
                    vue.$appConfig.apiUrls.account.login,
                    data,
                    onSuccess, 
                    onError
                );
            },
            getUserInfo(vue, login, token, onSuccess, onError) {
                const data = {login: login, token: token};               

                _signThenSendRequest.call(
                    vue, 
                    vue.$appConfig.apiUrls.account.info,
                    data,
                    onSuccess,
                    onError);
            },
            getAuthType(vue, login, captcha, onSuccess, onError) {
                const xml = _js2Xml({ login: login, captcha: captcha });

                _sendRequest.call(
                    vue,
                    vue.$appConfig.apiUrls.account.check,
                    xml,
                    onSuccess,
                    onError);
            },
            getSms: function (vue, login, pass, captcha, onSuccess, onError) {
                var xmlData = this.convertToXml(login, null, pass, captcha)
                this.sendPostRequest(vue, vue.$appConfig.apiUrls.account.getSms, xmlData, onSuccess, onError)
            },
            checkSms: function (vue, login, pass, smsCode, captcha, onSuccess, onError) {
                var xmlData = this.convertToXml(login, null, pass, captcha, smsCode)
                this.sendPostRequest(vue, vue.$appConfig.apiUrls.account.verifySms, xmlData, onSuccess, onError)
            },
            checkSmsNca: function (vue, login, pass, smsCode, captcha, onSuccess, onError) {
                var xmlData = this.convertToXml(login, null, pass, captcha, smsCode)
                vue.$ncalayer.signXml(xmlData, result => {
                    if (result.code === '500') {
                        vue.$ncalayer.breakSession(null)
                        return
                    }
                    var xml = result.responseObject.signedXml
                    this.sendPostRequest(vue, vue.$appConfig.apiUrls.account.verifySmsNca, xml, onSuccess, onError)
                })
            },
            getTaxOrgs: function (vue) {
                this.sendRequest(vue, vue.$appConfig.apiUrls.taxOrgs, null, result => {
                    vue.$store.commit('setTaxOrganizations', result)
                }, () => { })
            },
            getCities(vue, request) {
                const xmlData = _js2Xml({ payload: request.data });

                _sendRequest.call(
                    vue,
                    vue.$appConfig.apiUrls.info.city,
                    xmlData,
                    request.onSuccess,
                    request.onError);
            },
            getStreets(vue, request) {
                const xmlData = _js2Xml({ payload: request.data });

                _sendRequest.call(
                    vue,
                    vue.$appConfig.apiUrls.info.street,
                    xmlData,
                    request.onSuccess,
                    request.onError);
            },
            getHouses(vue, request) {
                const xmlData = _js2Xml({ payload: request.data });

                _sendRequest.call(
                    vue,
                    vue.$appConfig.apiUrls.info.home,
                    xmlData,
                    request.onSuccess,
                    request.onError);
            },
            sendRequest(vue, url, payload, onSuccess, onError) {
                if (!_tokenIsLive(vue.$store.getters.tokenExpiryDate)) {
                    vue.$store.commit('logout');
                    vue.$ncalayer.breakSession(null);
                    vue.$router.push('/login');

                    return;
                }
                
                const login = vue.$store.getters.getUserName;                
                const token = vue.$store.getters.token;

                const xmlData = _js2Xml({login, payload, token});
                
                const onSigned = result => {
                    if (result.code === '500') {
                        vue.$store.commit('logout');
                        vue.$ncalayer.breakSession(null);
                        vue.$router.push('/login');
                        return;
                    }

                   _sendRequest.call(
                       vue, 
                       url, 
                       result.responseObject.signedXml, 
                       onSuccess, 
                       onError);
                };

                vue.$ncalayer.signXml(xmlData, onSigned);
            },
            async sendRequestAsync(vue, url, payload, httpMethod) {
                const login = vue.$store.getters.getUserName;
                
                if (!_tokenIsLive(vue.$store.getters.tokenExpiryDate)) {
                    vue.$store.commit('logout');
                    vue.$ncalayer.breakSession(null);
                    vue.$router.push('/login');

                    return;
                }

                const token = vue.$store.getters.token;

                const xmlData = _js2Xml({login, payload, token});
                const promise = new Promise((resolve, reject) => {
                    const onSigned = async result => {
                        if (result.code === '500') {
                            vue.$store.commit('logout');
                            vue.$ncalayer.breakSession(null);
                            vue.$router.push('/login');
                            return;
                        }
    
                       _sendRequest.call(
                           vue, 
                           url,
                           result.responseObject.signedXml,
                           resolve,
                           reject,
                           httpMethod);
                    };
                    
                    vue.$ncalayer.signXml(xmlData, onSigned);
                });
                

                return await promise;
            },
            sendPostRequest: function (vue, url, data, onSuccess, onError) {
                if (process.env.NODE_ENV !== 'production') {
                    console.log(data)
                }
                var requestProps = {
                    headers: {
                        'Content-Type': 'text/plain'
                    }
                };

                vue.$http.post(url, data, requestProps).then(response => {
                    if (response.body.code === 100 || Array.isArray(response.body)) {
                        onSuccess(response.body)
                    } else {
                        onError(response.body.code)
                    }
                }, reject => {
                    onError(reject.body != null ? reject.body.code || 'unknownError' : 'unknownError')
                })
            },
            sendGetRequest(vue, url, onSuccess, onError) {
                _sendGetRequest.call(
                    vue,
                    url,
                    onSuccess,
                    onError)
            }
        },
            Vue.prototype.$miscUtil = {
                generateSelectList: function (data, idField, nameField) {
                    var list = []
                    data.forEach(function (element) {
                        list.push({ value: element[idField], text: element[nameField] })
                    })
                    return list
                }
            },
            Vue.objectPropertyToDate = function (obj) {
                for (var key in obj) {
                    if (key.toLowerCase().includes('date')) {
                        obj[key] = new Date(obj[key])
                    }
                }
                return obj
            }
    }
}

function _tokenIsLive(tokenExpiryDate) {
    return tokenExpiryDate != null && new Date() < tokenExpiryDate;
}

function _signThenSendRequest(url, data, onSuccess, onError){
    const xmlData = _js2Xml(data);
    
    const callback = response => {
        if (response.code === '500') {
            this.$ncalayer.breakSession(null);

            return;
        }

        _sendRequest.call(
            this,
            url,
            response.responseObject.signedXml,
            onSuccess, 
            onError
        );
    }

    this.$ncalayer.signXml(xmlData, callback);
}

function _sendGetRequest(url, onSuccess, onError) {
    const options = _getOptions(this.$store.getters.locale);
    const successHandler = _handleSuccess(url, onSuccess, onError);    
    const errorHandler = _handleError(onError);

    this.$http.get(url, options).then(successHandler, errorHandler);
}

function _sendRequest(url, data, onSuccess, onError, httpMethod) {
    const options = _getOptions(this.$store.getters.locale);
    const successHandler = _handleSuccess(url, onSuccess, onError);    
    const errorHandler = _handleError(onError);

    httpMethod = httpMethod == null ? "POST" : httpMethod;

    switch(httpMethod) {
        case "POST":
            this.$http.post(url, data, options).then(successHandler, errorHandler);
            break;
        
        case "PUT": 
            this.$http.put(url, data, options).then(successHandler, errorHandler);
            break;

        default:
            throw new Error(`Unsupported HTTP method: ${httpMethod}`);
    }
}

function _getOptions(locale) {
    return { 
        headers: { 
            'Content-Type': 'text/plain',
            'Accept-Language': locale === 'kz' 
            ? 'kk'
            : locale
        }
    };

}

function _handleSuccess(url, onSuccess, onError) {
    return response => {
        if (response.body.code !== 100) {
            const message = `Some error has been corruped when requesting data from server. Url: ${url}. Status code: ${response.body.code}.`;

            console.error(message);
    
            onError(response.body.code);
        }
        else 
            onSuccess(response.body.value);
    } 
}

function _handleError(onError) {
    return response => {
        console.error(response);

        const status = response.body != null && response.body.code != null
            ? response.body.code
            : 'unknownError';

        onError(status);
    }
}

function _js2Xml(jsData) {
    const data = _normalize(jsData);

    if (jsData.payload != null)
        data.payload = _normalize(jsData.payload);

    return convert.json2xml({ data: data }, {
        compact: true,
        ignoreComment: true,
        fullTagEmptyElement: true,
        elementNameFn: function (name) {
            return name.charAt(0).toUpperCase() + name.slice(1);
        }
    });
}

function _normalize(payload) {
    const normalizedPayload = {};

    const isStringEmpty = str => {
        return _.isString(str) && str == "";
    }

    for (let key in payload) {
        if (_.isNull(payload[key]) || _.isUndefined(payload[key]) || isStringEmpty(payload[key]))
            continue;

        if (payload[key] instanceof Date)
            normalizedPayload[key] = moment(payload[key]).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        else
            normalizedPayload[key] = payload[key];
    }

    return normalizedPayload;
}
